import { Layout as AntLayout, Space, Button, Typography } from 'antd';
import { MenuOutlined, ArrowLeftOutlined, DesktopOutlined, AppstoreOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
// [ẨN CHỌN CHI NHÁNH TRÊN NAV] Bỏ comment để hiện lại dropdown chọn chi nhánh
// ở header. Việc đổi chi nhánh vẫn làm được qua field "Chi nhánh" trong panel
// Thông tin đơn hàng ở màn tạo/sửa đơn (StoreBranchField, cùng useStoreSelection).
// import { StoreSelector } from './StoreSelector';
import { NotificationBell } from './NotificationBell';
import { HeaderUserMenu } from './HeaderUserMenu';
import { StockLookupButton } from '@/components/StockLookup';
import { usePosFullscreen } from '@/pages/POS/PosFullscreenContext';
import { ROUTES } from '@/constants/routes';
import { useRbac } from '@/hooks/useRbac';
import { MINIAPP_WAREHOUSE_ACCESS_PERMISSION } from '@/pages/Miniapp/permissions';

const { Header: AntHeader } = AntLayout;

interface HeaderProps {
  isMobile: boolean;
  onToggleSidebar?: () => void;
}

/**
 * App Shell topbar (EG-355 §4). 4 phần:
 *  - Store Selector (dropdown chọn chi nhánh làm việc)
 *  - Notification Bell (badge + popover 5 thông báo gần nhất)
 *  - User Avatar (dropdown: Profile / Đổi pw / Đăng xuất)
 *
 * Mobile: hamburger trái mở sidebar drawer.
 * POS route: nút back về danh sách đơn POS (trái) + nút Browser Fullscreen (phải).
 */
export const Header = ({ isMobile, onToggleSidebar }: HeaderProps) => {
  const { posAppFullscreen, toggleBrowserFS } = usePosFullscreen();
  const navigate = useNavigate();
  const { hasPermission } = useRbac();
  const canOpenMiniapp = hasPermission(MINIAPP_WAREHOUSE_ACCESS_PERMISSION);

  return (
    <AntHeader
      style={{
        background: '#fff',
        borderBottom: '1px solid #f0f0f0',
        padding: isMobile ? '0 12px' : '0 16px',
        height: 48,
        lineHeight: '48px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      {posAppFullscreen ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flex: 1, minWidth: 0 }}>
          <Button
            type="text"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate(ROUTES.orders.posList)}
            style={{ color: '#a4193d' }}
            aria-label="Quay lại đơn hàng"
            title="Quay lại đơn hàng"
          />
          {/* TCR-965: đổi "POS" → "Kênh ngoài sàn" cho khớp nhãn menu bên Sidebar. */}
          <Typography.Text strong style={{ color: '#a4193d', flexShrink: 0 }}>Kênh ngoài sàn</Typography.Text>
          {/* Portal target — POSPage renders PosTabsBar vào đây khi posAppFullscreen.
              flex-direction: column + justify-content: flex-end → tabs neo đáy Header
              để border-bottom của bar trùng border-bottom của Header (Chrome-tab style).
              Cross-axis stretch (default) → bar chiếm full chiều ngang slot. */}
          <div
            id="pos-tabs-portal-slot"
            style={{
              flex: 1,
              minWidth: 0,
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-end',
              overflow: 'hidden',
            }}
          />
        </div>
      ) : isMobile && onToggleSidebar ? (
        <Button
          type="text"
          icon={<MenuOutlined style={{ fontSize: 18 }} />}
          onClick={onToggleSidebar}
          aria-label="Mở menu"
        />
      ) : (
        <span />
      )}
      <Space size={isMobile ? 8 : 16} align="center">
        {/* [ẨN CHỌN CHI NHÁNH TRÊN NAV] Bỏ comment để hiện lại. */}
        {/* <StoreSelector /> */}
        {!posAppFullscreen && canOpenMiniapp && (
          <Button
            type="text"
            icon={<AppstoreOutlined />}
            onClick={() => navigate('/miniapp')}
            aria-label="Mở Miniapp kho"
            title="Miniapp kho"
          >
            {!isMobile && 'Miniapp kho'}
          </Button>
        )}
        <StockLookupButton />
        <NotificationBell />
        {posAppFullscreen && (
          <Button
            type="text"
            icon={<DesktopOutlined />}
            onClick={toggleBrowserFS}
            aria-label="Browser Fullscreen"
            title="Browser Fullscreen"
          />
        )}
        <HeaderUserMenu />
      </Space>
    </AntHeader>
  );
};
